import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalVariableService } from '../../service/global-variable.service';

@Component({
  selector: 'app-ers-banner',
  templateUrl: './ers-banner.component.html',
  styleUrls: ['./ers-banner.component.scss']
})
export class ErsBannerComponent {

  @Input() ersHeadline: string;
  @Input() lastWebPage: string;
  @Input() supplyChannel: string;
  @Input() businessType: string;

  constructor(private router: Router, private globalVariableService: GlobalVariableService) { }

  openThreePrForm() {
    // [routerLink]="'/service-lines/threepr-form'"
    this.globalVariableService.lastWebPageName = this.lastWebPage;
    this.globalVariableService.supplyChannelName = this.supplyChannel;
    this.globalVariableService.businessTypeName = this.businessType;

    this.router.navigate(['/service-lines/threepr-form']);
  }

}
